import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { MomentosWow } from '../../models/momentos-wow/momentoswow.model';
import { MomentoWowModal } from '../../models/momentos-wow/momentoswow.model'; // DTO para modal

@Injectable({
  providedIn: 'root',
})
export class MomentosWowService {
  // private apiUrl = `http://localhost:9180/ova/api/momentos-wow`;

  private apiUrl = `${ENV.HOST}${URL_MAP.API.MOMENTOS_WOW}`;

  constructor(private http: HttpClient) {}

  listarVisibles(idAsesor: string): Observable<MomentosWow[]> {
    return this.http.post<MomentosWow[]>(`${this.apiUrl}/visibles`, {
      idAsesor,
    });
  }

  obtenerModal(body: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiUrl}/modal`, body);
  }

  // Gestionar un momento wow
  gestionar(id: number): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/gestionar/${id}`, {});
  }

  // Consultar momentos wow desde el servicio externo
  consultarMomentosWow(cedulas: string): Observable<MomentoWowModal[]> {
    const body = {
      nombreClave: 'getMomentosWow',
      jsonParametros: JSON.stringify({
        prm_cedulas: cedulas, 
      }),
    };

    return this.http.post<MomentoWowModal[]>(
      `${this.apiUrl}/consultarMomentosWow`,
      body
    );
  }
}